import { defineNuxtPlugin } from 'nuxt/app'
import { createVuetify } from 'vuetify'
import { Touch } from 'vuetify/directives'

import { VApp, VStepper, VStepperHeader, VForm, VAppBar, VOverlay, VFooter, VAppBarNavIcon, VAvatar, VBadge, VBtn, VCard, VCardActions, VCardSubtitle, VCardText, VCardTitle, VCarousel, VCarouselItem, VCombobox, VContainer, VIcon, VImg, VList, VListItem, VListItemTitle, VNavigationDrawer, VSpacer, VTextField, VProgressCircular, VMain, VLayout, VFab, VBottomNavigation, VSelect, VSheet, VSlideGroup, VSlideGroupItem, VStepperItem, VDivider, VStepperWindowItem, VStepperWindow, VCheckbox } from 'vuetify/components'
import {
  Ripple, Intersect, Scroll,
} from 'vuetify/directives'
import { VStepperVertical, VStepperVerticalActions, VStepperVerticalItem } from 'vuetify/labs/VStepperVertical'

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    theme: {
      themes: {
        light: {
          dark: false,
          colors: {
            primary: '#993826',
            secondary: '#000000',
            background: '#f5f5f5',
            productBackground: '#f9f9f9',
            lightText: '#6c6c6c',
            blurple: '#635bff',
            pay: '#003087',
            pal: '#009CDE',
          },
          variables: {

          },
        },
      },
    },
    directives: {
      Ripple, Intersect, Scroll, Touch
    },
    icons: {
      defaultSet: 'mdi',
    },
    components: {
      VBtn,
      VAvatar,
      VCard,
      VCheckbox,
      VCardText,
      VCardActions,
      VCardTitle,
      VCardSubtitle,
      VForm,
      VStepperVertical,
      VStepperVerticalItem,
      VStepperVerticalActions,
      VIcon,
      VTextField,
      VFooter,
      VCombobox,
      VContainer,
      VNavigationDrawer,
      VApp,
      VList,
      VImg,
      VFab,
      VListItem,
      VListItemTitle,
      VBottomNavigation,
      VStepperItem,
      VDivider,
      VStepperHeader,
      VStepperWindow,
      VStepperWindowItem,
      VAppBar,
      VBadge,
      VSpacer,
      VSelect,
      VSheet,
      VSlideGroup,
      VSlideGroupItem,
      VAppBarNavIcon,
      VCarousel,
      VCarouselItem,
      VProgressCircular,
      VStepper,
      VMain,
      VLayout,
      VOverlay,
    },
    ssr: true,
  })

  nuxtApp.vueApp.use(vuetify)
})
